export default class CustomStyle {
    private style: HTMLLinkElement = null;
    public isLoading = true;

    constructor(private readonly document: Document) {
        this.document = document;

        this.style = this.document.createElement('link');
    }

    public async mountStyle(color: string, customStyle?: string): Promise<HTMLLinkElement> {
        return new Promise((resolve, reject) => {
            try {
                if (customStyle) {
                    const style = this.document.createElement('style');
                    style.textContent = customStyle;
                    this.document.head.appendChild(style);
                }
                this.setStyleLoadWatcher();
                this.setCustomStyleUrl(color);
                this.loadStyle();
                resolve(this.style);
            } catch (err) {
                reject(err);
            }
        });
    }

    private setStyleLoadWatcher(): void {
        this.style.onload = () => {
            this.isLoading = false;
        };
    }

    private setCustomStyleUrl(color: string): void {
        this.style.setAttribute('href', `https://bootstrap.solucx.com.br/?color=${color}`);
        this.style.setAttribute('rel', 'stylesheet');
    }

    private loadStyle(): void {
        this.document.head.appendChild(this.style);
    }
}
